import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4c022af1"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "dialog-footer"
};
import { reactive, computed, ref, watch, nextTick } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import { addCaseCategoryApi } from "@/service/modules/case";
export default /*#__PURE__*/_defineComponent({
  __name: 'class-dialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    itemData: {
      type: Object,
      default: () => {}
    },
    dialogType: {
      type: String,
      default: "add"
    }
  },
  emits: ["closeDialog", "restData"],
  setup(__props, {
    emit: __emit
  }) {
    const route = useRoute();
    const router = useRouter();
    const props = __props;
    const subBtnLoading = ref(false);
    const title = computed(() => {
      if (props.dialogType === "add") {
        return "新增分类";
      } else if (props.dialogType === "edit") {
        return "编辑分类";
      }
    });
    const emit = __emit;
    const formRef = ref();
    const rules = {
      name: [{
        required: true,
        message: "请输入名称",
        trigger: "blur"
      }]
    };
    function closeDialog() {
      if (subBtnLoading.value) return ElMessage.warning("正在保存，请稍后~~");
      restForm();
      formRef.value?.resetFields();
      emit("closeDialog");
    }
    const form = reactive({
      id: null,
      display_order: 0,
      name: ""
    });
    function restForm() {
      form.id = null;
      form.name = "";
      form.display_order = 0;
    }
    function handleFooterBtn(actionType) {
      if (!actionType) {
        closeDialog();
        return;
      }
      formRef.value?.validate(valid => {
        if (valid) {
          submit();
        }
      });
    }
    async function submit() {
      subBtnLoading.value = true;
      if (props.dialogType === "add") {
        delete form.id;
      }
      let query = JSON.parse(JSON.stringify(form));
      try {
        let res = await addCaseCategoryApi(query);
        ElMessage.success(props.dialogType === "add" ? "添加成功" : "修改成功");
        restForm();
        formRef.value?.resetFields();
        emit("restData");
      } catch {} finally {
        subBtnLoading.value = false;
      }
    }
    watch(() => props.dialogVisible, newValue => {
      if (newValue) {
        nextTick(() => {
          if (props.dialogType === "edit") {
            for (let key in form) {
              form[key] = props.itemData[key];
            }
          }
        });
      }
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_dialog, {
        "model-value": __props.dialogVisible,
        title: title.value,
        width: "20%",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": true,
        "before-close": closeDialog
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_1, [_createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = $event => handleFooterBtn(false))
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          loading: subBtnLoading.value,
          onClick: _cache[3] || (_cache[3] = $event => handleFooterBtn(true)),
          type: "primary"
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: form,
          rules: rules,
          "label-width": "auto"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "分类名称",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.name = $event),
              maxlength: "5",
              placeholder: "请输入"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "排序"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              class: "scort",
              modelValue: form.display_order,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.display_order = $event),
              type: "number"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["model-value", "title"])]);
    };
  }
});